﻿//https://en.wikipedia.org/wiki/Rules_of_cribbage

import EventEmitter from './EventEmitter.js';
import StateManager from './StateManager.js';

import Deck from './Deck.js';
import Card from './Card.js';
//import PlayerComputer from './PlayerComputer.js';
import StatePreGame from './StatePreGame.js';
import StateStartRound from './StateStartRound.js';
import StateCut from './StateCut.js';
import StateShuffle from './StateShuffle.js';
import StateShuffleCut from './StateShuffleCut.js';
import StateCrib from './StateCrib.js';
import StateStarter from './StateStarter.js';
import StatePlay from './StatePlay.js';
//import StateShow from './StateShow.js';
import StateShowNonDealerHand from './StateShowNonDealerHand.js';
//import StateScoreNonDealerHand from './StateScoreNonDealerHand.js';
import StateShowDealerHand from './StateShowDealerHand.js';
import StateShowCrib from './StateShowCrib.js';
import StateEndRound from './StateEndRound.js';
import StateEndMatch from './StateEndMatch.js';
import StateQuit from './StateQuit.js';
import ScoreCalculator from './ScoreCalculator.js';
import Analyzer from './Analyzer.js';

import JsonDiffPatch from '../lib/jsondiffpatch.esm.js';


//https://en.wikipedia.org/wiki/Cribbage
//todo: move cards manangement to base class? 
//todo: or board class or dealer class or static class, that malipulated the cards array that lives on cribbage Model. if board class how would events bubble up? board events would call cribbage(game) events
//could this class be a gerenic game class with cribage on top of it? It should have state control and/or board class and/or eventEmitter/action
//Action: action command: http://www.habrador.com/tutorials/programming-patterns/1-command-pattern/ or http://www.dofactory.com/net/command-design-pattern
//may be mixing up state and command base class - https://www.codeproject.com/Articles/12263/The-Command-Pattern-and-MVC-Architecture
//State: extention of this logic class to keep code cleaner with less switch cases
//Model: could move all data to variable container with zero logic, might need to change states to be string based, but then it cant create new state on change, just route to state
export default class Cribbage extends StateManager {
    constructor() {
        super();
        this.id = Math.floor(Math.random() * 10000000);
        this.event = new EventEmitter();
        this.jsondiffpatch = JsonDiffPatch;
        this.isPrivateGame = null;
        this.allowFullChat = null;
        this.isRanked = null;
        this.lastGameData = null;

        this.debug = false;

        this.cards = new Deck().createDeck();//this.board = new GameBoard();//all piles/cards/action(draw/move/shuffle) //this.piles = []; 
        this.tablePositions = ["player1", "player2"]; //could be position at table instead of player
        this.player1 = null;
        this.player2 = null;
        this.flowControl = null;
        //todo: remove playercomputer from player1/player2 and move to user.
        //player1/player2 should be table positions no players or users
        this.users = [];
        this.matchWinner = null;
        this.elaspedTime = null;
        this.lastActionTime = null;
        this.eventLog = [];
        this.playerTurn = "player1";
        this.dealerStart = null;
        this.dealer = null;
        this.playCount = 0;
        this.roundNumber = 0;
        this.roundLog = [];
        this.sortHands = true;
        this.matchPoints = {};
        this.matchWinPoints = 121; //If one player reaches the target (usually 61 or 121), the game ends immediately and that player wins. 
        this.matchSkunkPoints = 91;
        this.startTime = Date.now();
        this.calc = new ScoreCalculator();
        this.analyzer = new Analyzer();
        this.currentState = "";
        this.allowRematch = true;
        this.quitReason = null;


        //note: should join externally, but for now, just add it
        //note: should the player/computer join and be added to the list so it can be auto cleaned up?
        //this.playerComputer = new PlayerComputer(this);

        //should add all states here with their keys
        this.stateManager = new StateManager();
        this.stateManager.addState("preGame", new StatePreGame(this));
        this.stateManager.addState("startRound", new StateStartRound(this));
        this.stateManager.addState("cut", new StateCut(this));
        this.stateManager.addState("shuffle", new StateShuffle(this));
        this.stateManager.addState("shuffleCut", new StateShuffleCut(this));
        this.stateManager.addState("crib", new StateCrib(this));
        this.stateManager.addState("starter", new StateStarter(this));
        this.stateManager.addState("play", new StatePlay(this));
        //this.stateManager.addState("show", new StateShow(this));
        this.stateManager.addState("showNonDealerHand", new StateShowNonDealerHand(this));
        //this.stateManager.addState("scoreNonDealerHand", new StateScoreNonDealerHand(this));
        this.stateManager.addState("showDealerHand", new StateShowDealerHand(this));
        this.stateManager.addState("showCrib", new StateShowCrib(this));
        this.stateManager.addState("endRound", new StateEndRound(this));//might not need this state
        this.stateManager.addState("endMatch", new StateEndMatch(this));
        this.stateManager.addState("quit", new StateQuit(this));


        this.setState("preGame");

        //or 
        //this.states["quit"] = new StateQuit(this);
        //this.states["quit"] = new StateQuit(this);
        //this.states["quit"] = new StateQuit(this);
        //this.states["quit"] = new StateQuit(this);

    }
    join(user) {
        //todo: remove link from game to user.  Create dupe player owned by game
        //todo: add user to user list for tick() and keep alive from GC. 
        let player = {
            id: user.id,
            email: user.email,
            name: user.name,
            avatar: user.avatar,
            rank: user.rank,
            isDisconnected: false,
            behavior: user.behavior,
            difficulty: user.difficulty
        }
        let tablePosition = null;

        //try to rejoin the game
        if (this.player1 && this.player1.id && this.player1.id === player.id) {
            this.player1 = player;
            this.sendEvent("join", "rejoin", player);
            tablePosition = "player1"
            return tablePosition;
        }
        if (this.player2 && this.player2.id && this.player2.id === player.id) {
            this.player2 = player;
            this.sendEvent("join", "rejoin", player);
            tablePosition = "player2"
            return tablePosition;
        }

        //find an empty position
        if (!this.player1) {
            this.player1 = player;
            this.sendEvent("join", "fillEmpty", player);
            tablePosition = "player1"
            return tablePosition;
        }
        if (!this.player2) {
            this.player2 = player;
            this.sendEvent("join", "fillEmpty", player);
            tablePosition = "player2"
            return tablePosition;
        }

        return false;
    }

    // leave1(user) {
    //     //find user 
    //     //remove user
    //     //send event
    //     let player = {
    //         id: user.id,
    //         name: user.name,
    //         avatar: user.avatar,
    //         rank: user.rank,
    //     };

    //     if (this.player1) {
    //         if (this.player1.name === player.name) {
    //             this.player1 = null;
    //             this.sendEvent("leave", player);
    //         }
    //     }
    //     if (this.player2) {
    //         if (this.player2.name === player.name) {
    //             this.player2 = null;
    //             this.sendEvent("leave", player);
    //         }
    //     }
    //     //reset game if missing a player
    //     if (this.player1 == null || this.player2 == null) {
    //         if (this.currentState !== "preGame")
    //             this.setState("preGame");
    //     }

    // }
    isPreGameState() {
        let state = this.currentState;
        let preGameState = state === "preGame";
        return preGameState;
    }
    leave(user, reason) {
        let state = this.currentState;
        //find user 
        //set isDisconnected
        //send event
        let player = {
            id: user.id,
            email: user.email,
            name: user.name,
            avatar: user.avatar,
            rank: user.rank,
            isDisconnected: true
        };

        if (this.player1) {
            if (this.player1.id === player.id) {
                this.player1.isDisconnected = true;
                this.sendEvent("disconnect", reason, player);
                this.quit("leave:" + reason, "player1");
            }
        }
        if (this.player2) {
            if (this.player2.id === player.id) {
                this.player2.isDisconnected = true;
                this.sendEvent("disconnect", reason, player);
                this.quit("leave:" + reason, "player2");
            }
        }
        //if pre game, then reset the game - not needed if there is a clear start
        let preGameState = this.isPreGameState();
        if (preGameState) {
            //remove player
            if (this.player1) {
                if (this.player1.id === player.id) {
                    this.player1 = null;
                    this.sendEvent("leave", reason, player);
                }
            }
            if (this.player2) {
                if (this.player2.id === player.id) {
                    this.player2 = null;
                    this.sendEvent("leave", reason, player);
                }
            }
            //this would not be needed if once the game started it could not be reset
            //reset game if missing a player and game not in session (or first round)
            if (this.player1 == null || this.player2 == null) {
                if (this.currentState !== "preGame")
                    this.setState("preGame");
            }
        }

    }
    disconnect(user, reason) {
        let player = {
            id: user.id,
            name: user.name,
            avatar: user.avatar,
            rank: user.rank,
            isDisconnected: true
        };
        if (this.player1) {
            if (this.player1.id === player.id) {
                this.player1.isDisconnected = true;
                this.sendEvent("disconnect", reason, player);
            }
        }
        if (this.player2) {
            if (this.player2.id === player.id) {
                this.player2.isDisconnected = true;
                this.sendEvent("disconnect", reason, player);
            }
        }
        //if early game just remove the player and reset the game
        let preGameState = this.isPreGameState();
        if (preGameState) {
            //remove player
            if (this.player1) {
                if (this.player1.id === player.id) {
                    this.player1 = null;
                    this.sendEvent("leave", reason, player);
                }
            }
            if (this.player2) {
                if (this.player2.id === player.id) {
                    this.player2 = null;
                    this.sendEvent("leave", reason, player);
                }
            }
            //this would not be needed if once the game started it could not be reset
            //reset game if missing a player and game not in session (or first round)
            if (this.player1 == null || this.player2 == null) {
                if (this.currentState !== "preGame")
                    this.setState("preGame");
            }
        }
    }
    chat(message, player) {
        let isMuted = false;

        if (player === "player1" && this.player1) {
            isMuted = this.player1.isMuted
        }
        if (player === "player2" && this.player2) {
            isMuted = this.player2.isMuted
        }
        if (!isMuted) {
            this.sendEvent("chat", message, player);
        }
    }
    mute(player) {
        if (player === "player1" && this.player1) {
            this.player1.isMuted = true;
        }
        if (player === "player2" && this.player2) {
            this.player2.isMuted = true;
        }
    }
    startPlayTimer(duration, player) {
        this.sendEvent("startPlayTimer", duration, player);
    }
    stopPlayTimer(player) {
        this.sendEvent("stopPlayTimer", 0, player);
    }
    tick(value, player) {
        if (this.player1 && this.player1.tick) {
            this.player1.tick();
        }
        if (this.player2 && this.player2.tick) {
            this.player2.tick();
        }
        if (this.users) {
            //clean up old players
            for (let i = 0; i < this.users.length; i++) {
                let user = this.users[i];
                if (user && user.tick) {
                    user.tick();
                }
            }
        }
    }
    destroy() {


        if (this.player1 && this.player1.destroy) this.player1.destroy();
        this.player1 = null;
        if (this.player2 && this.player2.destroy) this.player2.destroy();
        this.player2 = null;

        //clean up flow control
        if (this.flowControl && this.flowControl.destroy) this.flowControl.destroy();
        this.flowControl = null;

        //clean up old players
        for (let i = 0; i < this.users.length; i++) {
            let user = this.users[i];
            if (user && user.destroy) {
                user.destroy();
            }
        }
        this.users = [];


        //remove all event listener
        this.event.removeAllListener();


    }
    //--------event dispatcher / logger -----------
    sendEvent(event, value, player) {
        this.logEvent(event, value, player);

        this.event.emit(event, value, player);
    }
    logEvent(event, value, player) {
        let eventItem = { 'event': event, 'value': value, 'player': player, 'timestamp': this.getElaspedTime() };
        this.eventLog.push(eventItem);
        if (this.debug === true) {
            this.debugLog(eventItem);
        }
    }
    debugLog(data) {
        //debug console
        if (console.log !== undefined && this.debug === true) {
            let msg = JSON.stringify(data, null, 0);
            console.log(this.id + "-" + msg); // console.log(JSON.stringify(eventItem, null, 0));
        }
    }
    getElaspedTime() {
        let timeStamp = (Date.now() - (this.startTime || 0)) / 1000;
        return timeStamp;
    }
    getElaspedIdelTime(player) {
        if (!this.eventLog) return 0;
        let playerEvents = this.eventLog.filter(eventLog => eventLog.player === player);
        let maxTimeStamp = playerEvents.reduce((a, b) => Math.max(a.timestamp || 0, b.timestamp || 0), 0);
        let gameElaspedTime = this.getElaspedTime();
        let elaspedTime = gameElaspedTime - maxTimeStamp;
        return elaspedTime;
    }
    //------------StateManager------------------------

    setState(stateName) {
        this.currentState = stateName;
        if (this.currentState === this.stateManager.currentState) return;
        this.stateManager.setState(stateName);
        this.sendEvent("stateChange", stateName);
    }

    //addState(stateName, state) {
    //    this.states[stateName] = state;
    //}
    //------------Cribbage Game Command Router / Interface------------------------
    action(command, value, player) {
        //could be done with an array of routers rather than a switch case
        let state = this.stateManager.getCurrentState();

        // //check if possible action
        // let stateActions = state.getActions().map(x => x.command);
        // let appActions = ["save", "quit"];
        // let allActions = stateActions.concat(appActions) ;
        // if (allActions.includes(command) === false) {
        //     this.unknownCommand(command, value, player);
        //     return;
        // }


        //todo: log event is done in sendEvent
        this.sendEvent("action", { 'command': command, 'value': value }, player);

        let actionSuccessful = false;
        //exec local actions ,then water fall to child state actions
        switch (command) {
            case "save": this.save(); break;
            case "quit":
                this.quit(value, player);
                actionSuccessful = true;
                break;
            case "join":
                this.join(value, player);
                actionSuccessful = true;
                break;
            case "leave":
                this.leave(value, player);
                actionSuccessful = true;
                break;
            case "chat":
                this.chat(value, player);
                actionSuccessful = true;
                break;
            case "tick":
                this.tick(value, player);
                actionSuccessful = true;
                break;
            case "startPlayTimer":
                this.startPlayTimer(value, player);
                actionSuccessful = true;
                break;
            case "stopPlayTimer":
                this.stopPlayTimer(value, player);
                actionSuccessful = true;
                break;
            default:
                let state = this.stateManager.getCurrentState();
                actionSuccessful = state.action(command, value, player);
            //todo: update all action to return true or false if action worked
        }

        //logEvent("action: "+ command + ":" + value + ":" +player);
        if (actionSuccessful) {
            this.lastActionTime = this.getElaspedTime();
            this.sendEvent("actionEnded", { 'command': command, 'value': value }, player);
        }

        ////todo: remove and just use action Ended and check for turn
        ////notify player to make next action
        ////there is an issue with computer and cli version with "actionEnded" causeing it to trigger the event many times with stale data.
        ////for example.  this.playerTurn is set after all the event, but when the 
        ////listener gets the event the game.playerTurn has been set so it think all the events were set to game.playerTurn,
        ////but when it was set only at the last event.  it needs a snap shot of the data or a way to wait until all are done on the stack.
        ////need event after all events are done, pending action
        //this.sendEvent("onTurn", this.playerTurn);

    }
    //note: states to call this directly instead of raw event? or just return false
    invalidMove(invalidMove, player) {
        this.sendEvent("invalidMove", invalidMove);
    }
    unknownCommand(command, value, player) {
        this.sendEvent("unknownCommand",
            { 'command': command, 'value': value },
            player);
    }
    getActions(player) {
        let state = this.stateManager.getState(this.currentState);
        if (!state) {
            console.warn("Game state is null");
            return [];
        }
        let actions = state.getActions(player);
        // //add local actions too not just child state
        // actions.push({ command: "quit", value: null });
        //actions.push({ command: "save", value: null });
        return actions;
    }


    //------------Cribbage Game Logic------------------------
    nextState() {
        let state = this.currentState;

        //todo: control state flow here?
    }
    forceWin(player) {
        const matchWinner = player;
        const isSkunked = this.isEarlySkunk(matchWinner);
        this.matchEnd(matchWinner, isSkunked);
    }
    isEarlySkunk(winner) {
        //player quit preskunk logic should be done in the Cribbage logic
        let positions = this.tablePositions;
        for (let i = 0; i < positions.length; i++) {
            let position = positions[i];
            let pointDif = this.matchPoints[winner] - this.matchPoints[position];
            if (pointDif >= 30) {
                return true;
            }
        }
    }

    checkForEndOfMatch() {
        //In a two player game of cribbage a player scores one match point for each game won. 
        //Their opponent will begin the next game as first dealer.
        //If a player skunks their opponent (reaches 121 points before their opponent scores 91 points),
        //then that player scores one extra match point for that game (two match points in total). 

        if (this.matchPoints["player1"] >= this.matchWinPoints) {//matchWinPoints = 121
            return true;
        }
        if (this.matchPoints["player2"] >= this.matchWinPoints) {//matchWinPoints = 121
            return true;
        }
    }
    matchEnd(matchWinner, isSkunked) {
        //check for winner
        if (this.matchPoints["player1"] >= this.matchWinPoints) //matchWinPoints = 121
            this.matchWinner = "player1";
        if (this.matchPoints["player2"] >= this.matchWinPoints) //matchWinPoints = 121
            this.matchWinner = "player2";

        //check for skunks (reaches 121 points before their opponent scores 91 points)
        if (this.matchPoints["player2"] < this.matchSkunkPoints) //skunk = 91
            this.isSkunked = true;
        if (this.matchPoints["player1"] < this.matchSkunkPoints)//skunk = 91
            this.isSkunked = true;


        //check for overrides
        if (isSkunked) this.isSkunked = isSkunked;
        if (matchWinner) this.matchWinner = matchWinner;

        this.setState("endMatch");
    }
    logHands(roundNumber, preHand1, preHand2) {

        if (!roundNumber) roundNumber = this.roundNumber;

        let round = this.getRoundLog(roundNumber);

        //get hand1
        let hand1 = this.getPileIDs("hand1");
        round.hand1 = hand1;
        //get hand2
        let hand2 = this.getPileIDs("hand2");
        round.hand2 = hand2;
        //get crib1
        let crib1 = this.getPileIDs("crib1");
        round.crib1 = crib1;
        //get crib2
        let crib2 = this.getPileIDs("crib2");
        if (crib1.length > 0)
            round.crib = crib1;
        if (crib2.length > 0)
            round.crib = crib2;
        //get starterCard
        let starterCard = this.getStarterCard();
        round.starterCard = starterCard ? starterCard.id : null;
        //get dealer
        round.dealer = this.dealer;
        round.preHand1 = preHand1;
        round.preHand2 = preHand2;


    }
    logPegging(roundNumber) {

        if (!roundNumber) roundNumber = this.roundNumber;

        let round = this.getRoundLog(roundNumber);

        //get pegging
        let pegging = this.getPileIDs("played");
        round.pegging = pegging;

    }
    awardPoints(points, player, reason, pile, cards) {
        let pointLog = {
            'points': points,
            'player': player,
            'reason': reason,
            'pile': pile,
            'cards': cards
        };
        this.awardPointsArray([pointLog]);
        return points;
    }
    awardPointsArray(pointLogs) {
        let roundNumber = this.roundNumber;
        let currentState = this.currentState;


        if (pointLogs === undefined) return;
        if (pointLogs.length === 0) return;
        let pointArray = [];
        for (let i = 0; i < pointLogs.length; i++) {
            let pointLog = pointLogs[i];
            pointLog.state = currentState;
            pointLog.round = roundNumber;
            //strip out the card ids
            if (pointLog.cards !== undefined) {
                pointLog.cards = pointLog.cards.map(function (c) {
                    if (c.id !== undefined) return c.id;
                    else return c;
                });
            }
            let points = pointLog.points;
            let player = pointLog.player;

            //update points - done here so it does not have to be done in each state
            //note: update player totals for round/match from event log? or just running total


            // //update round Log
            // if (this.roundLog === undefined) this.roundLog = [];
            // if (this.roundLog[roundNumber] === undefined) this.roundLog[roundNumber] = {};
            // if (this.roundLog[roundNumber].points === undefined) this.roundLog[roundNumber].points = [];
            // this.roundLog[roundNumber].points.push(pointLog);

            //get points from log

            //save points in round log
            let round = this.getRoundLog(roundNumber);
            round.points.push(pointLog);

            //if (this.points === undefined) this.points = [];
            //this.points.push(pointLog);


            //current
            pointArray.push(pointLog);

            //update player total for match
            if (this.matchPoints[player] === undefined) this.matchPoints[player] = 0;
            this.matchPoints[player] = this.matchPoints[player] + points;

            //can't have more than max points
            if (this.matchPoints[player] > this.matchWinPoints) this.matchPoints[player] = this.matchWinPoints;

            //sendEvent also logs the points
            this.sendEvent("awardPoints", pointLog);
        }
        //todo: listen on UI.  If more than one say group name (hand name, such as Hand +12/Crib +8)
        this.sendEvent("awardPointArray", pointArray);
        this.sendEvent("roundPoints", null);//value chagned
        this.sendEvent("matchPoints", this.matchPoints);//value chagned

        if (this.checkForEndOfMatch()) {
            this.matchEnd();
        }

    }
    analyzeHand(player, roundNumber) {
        let handName = player === "player1" ? "hand1" : "hand2";
        let preHandName = player === "player1" ? "preHand1" : "preHand2";

        //get round number
        if (!roundNumber) roundNumber = this.roundNumber;
        //get points from log
        let round = this.getRoundLog(roundNumber);
        if (!round) return null;

        let handIds = round[handName];
        let preHandIds = round[preHandName]
        let isDealer = round.dealer === player;

        let analysis = this.analyzer.analyzeHandByIds(preHandIds, isDealer, handIds);
        return analysis;
    }
    analyzeSeletedHand(player, roundNumber) {
        let analysis = this.analyzeHand(player, roundNumber);
        let option = analysis.options.find(o => o.selected == true);

        return option ? option.avgScorePercentile : null;
    }
    scoreHandDetail(player, roundNumber) {

        //get player name
        let playerName = player;
        if (player === "player1" && this.player1) playerName = this.player1.name;
        if (player === "player2" && this.player2) playerName = this.player2.name;

        //get round number
        if (!roundNumber) roundNumber = this.roundNumber;

        //get points from log
        let round = this.getRoundLog(roundNumber);

        //get filtered points
        let points = round.points.filter(p => p.round === roundNumber && p.player === player && p.pile === 'hand');
        //starter card
        let starterCard = round.starterCard;
        //hand cards
        let hand = [];
        if (player === "player1") hand = round.hand1;
        if (player === "player2") hand = round.hand2;



        let summary = {
            name: playerName,
            starterCard: starterCard,
            hand: hand,
            points: points
        };
        return summary;
    }
    scoreCribDetail(roundNumber) {

        //get round number
        if (!roundNumber) roundNumber = this.roundNumber;

        let round = this.getRoundLog(roundNumber);

        //return empty if no round data found
        if (!round) {
            let summary = {
                name: 'Crib',
                starterCard: null,
                hand: [],
                points: []
            };
            return summary;
        }
        //get points from log
        let points = round.points.filter(p => p.round === roundNumber && p.pile === 'crib');
        //starter card
        let starterCard = round.starterCard;
        //crib cards
        let hand = round.crib;

        let summary = {
            starterCard: starterCard,
            hand: hand,
            points: points
        };
        return summary;
    }
    matchSummary() {

        let roundLog = this.roundLog || [];

        let pointArrays = roundLog.map(round => {
            return round && round.points || [];
        })
        let pointArraysFiltered = pointArrays.filter(points => {
            return points && points.length > 0;
        });
        var points = [].concat.apply([], pointArraysFiltered) || [];

        let summary = this.pointSummary(points);
        return summary;
    }
    roundSummary(roundNumber) {
        //get round number
        if (!roundNumber) roundNumber = this.roundNumber;

        let round = this.getRoundLog(roundNumber);

        let currentRoundPoints = round.points || [];

        let summary = this.pointSummary(currentRoundPoints);


        //get analyzeScore
        let optimalAvgHand1 = this.analyzeSeletedHand("player1");
        let optimalAvgHand2 = this.analyzeSeletedHand("player2");
        summary["player1"].analyzerScore = optimalAvgHand1;
        summary["player2"].analyzerScore = optimalAvgHand2;

        //get player isDealer
        if (this.dealer) summary[this.dealer].isDealer = true;

        //get player rank
        if (this.player1) summary["player1"].rank = this.player1.rank;
        if (this.player2) summary["player2"].rank = this.player2.rank;

        //get card 
        summary["player1"].preHand = round.preHand1;
        summary["player2"].preHand = round.preHand2;

        summary["round"] = round.round;



        return summary;
    }
    pointSummary(roundPoints) {
        //get player name
        let player1 = this.player1 ? this.player1.name : "player1";
        let player2 = this.player2 ? this.player2.name : "player2";

        let summary =
        {
            "player1": {
                "name": player1,
                "starter": 0,
                "play": 0,
                "hand": 0,
                "crib": 0,
                "total": 0
            },
            "player2": {
                "name": player2,
                "starter": 0,
                "peg": 0,
                "hand": 0,
                "crib": 0,
                "total": 0
            }
        }


        if (roundPoints === undefined) return summary;
        for (let i = 0; i < roundPoints.length; i++) {
            let pointLog = roundPoints[i];
            if (summary[pointLog.player] === undefined)
                summary[pointLog.player] = {};
            if (summary[pointLog.player][pointLog.pile] === undefined)
                summary[pointLog.player][pointLog.pile] = 0;
            summary[pointLog.player][pointLog.pile] += pointLog.points;
            if (summary[pointLog.player]["total"] === undefined)
                summary[pointLog.player]["total"] = 0;
            summary[pointLog.player]["total"] += pointLog.points;
        }
        return summary;
    }
    getRoundLog(roundNumber) {

        if (!this.roundLog) this.roundLog = [];
        if (!this.roundLog[roundNumber]) {
            this.roundLog[roundNumber] = {
                round: roundNumber,
                points: [],
                hand1: [],
                hand2: [],
                crib: [],
                starterCard: null,
                dealer: null,
                pegging: []
            };
        }

        let round = this.roundLog[roundNumber];

        return round;
    }
    getHand() {
        //starter card
        let deck = this.getPile("deck");
        if (deck.length === 0) return null;
        let starterCard = deck[deck.length - 1];
        return starterCard;
    }
    getStarterCard() {
        //starter card
        let deck = this.getPile("deck");
        if (deck.length === 0) return null;
        let starterCard = deck[deck.length - 1];
        return starterCard;
    }
    canConfirm(player) {
        if (!player) return false;
        let playerHandName = player === "player1" ? "hand1" : "hand2";
        let pileHand = this.getPile(playerHandName);
        let selectedCards = pileHand.filter(card => card.isSelected);

        if (selectedCards.length !== 2) return false;
        if (pileHand.length !== 6) return false;

        return true;
    }
    canSort(player) {
        if (!player) return false;
        if (this.sortHands) return false;
        let playerHandName = player === "player1" ? "hand1" : "hand2";
        let pileHand = this.getPile(playerHandName);
        let selectedCards = pileHand.filter(card => card.isSelected);

        if (selectedCards.length < 2 && pileHand.length == 6) return true;
    }
    canReady(player) {
        if (!player) return false;
        let state = this.currentState;
        let player1 = this.player1;
        let player2 = this.player2;

        if (state !== "preGame")
            return false;
        if (player === "player1" && player1 && player1.ready)
            return false;
        if (player === "player2" && player2 && player2.ready)
            return false;
        if (!player1 || Object.keys(player1).length == 0) //missing a player
            return false;
        if (!player2 || Object.keys(player2).length == 0) //missing a player
            return false;
        if (state === "preGame")
            return true;
    }
    gameInSession() {
        //rules to allow quit without penalty
        let state = this.currentState;
        let roundNumber = this.roundNumber;
        //let allowQuitStates = ["preGame", "endMatch", "quit"];
        //let inSession = !allowQuitStates.includes(state) && roundNumber > 1;

        let inSession = false;
        if (state === "startRound") inSession = true;
        if (state === "cut") inSession = true;
        if (state === "shuffle") inSession = true;
        if (state === "crib") inSession = true;
        if (state === "play") inSession = true;
        if (state === "showNonDealerHand") inSession = true;
        if (state === "showDealerHand") inSession = true;
        if (state === "showCrib") inSession = true;
        if (state === "endRound") inSession = true;
        // if(allowQuitStates.includes(state)) inSession = false;
        return inSession;
    }
    canQuit(player) {
        if (!player) return true;
        //rules to allow quit without penalty
        let bothPlayersInGame = true;
        if (!this.player1 || this.player1.isDisconnected) bothPlayersInGame = false;
        if (!this.player2 || this.player2.isDisconnected) bothPlayersInGame = false;
        let isPrivateGame = this.isPrivateGame;
        let gameInSession = this.gameInSession();
        let allowQuit = !bothPlayersInGame || !gameInSession || isPrivateGame;
        return allowQuit;
    }
    quit(value, player) {
        let isGameInSession = this.gameInSession();
        //todo: use canQuit() to determine if game a penalty should be applied. move !(this.player2 && this.player2.isDisconnected) to canQuit()
        if (isGameInSession) {
            if (player == "player1" && !(this.player2 && this.player2.isDisconnected)) {
                this.quitReason = "Quit";
                if (value) this.quitReason = value;
                if (this.player1 && this.player1.isDisconnected) this.quitReason = "Disconnected";

                this.forceWin("player2");
            }
            if (player == "player2" && !(this.player1 && this.player1.isDisconnected)) {
                this.quitReason = "Quit";
                if (value) this.quitReason = value;
                if (this.player2 && this.player2.isDisconnected) this.quitReason = "Disconnected";

                this.forceWin("player1");
            }

            this.sendEvent("quit", value, player);
            if (player === "player1") {
                this.messagePlayer1 = value;
            } else {
                this.messagePlayer2 = value;
            }
        }
    }
    cleanUp() {
        //remove all event listeners from players/computers/ui's
        this.listeners = new Map();
    }
    save(includeLogs) {
        //could move all data to variable container with zero logic, might need to change states to be string based, but then it cant create new state on change, just route to state
        let data = {};
        data.id = this.id;
        data.level = this.level;
        data.isPrivateGame = this.isPrivateGame;
        data.allowFullChat = this.allowFullChat;
        data.isRanked = this.isRanked;
        data.room = this.room;
        data.cards = this.cards;
        data.tablePositions = this.tablePositions;
        data.player1 = {};
        data.player2 = {};
        if (this.player1) {
            data.player1 = {
                playerName: this.player1.playerName,
                delay: this.player1.delay,
                behavior: this.player1.behavior,
                id: this.player1.id,
                email: this.player1.email,
                name: this.player1.name,
                avatar: this.player1.avatar,
                rating: this.player1.rating,
                rank: this.player1.rank,
                difficulty: this.player1.difficulty,
                isDisconnected: this.player1.isDisconnected,
                isMuted: this.player1.isMuted,
                ready: this.player1.ready,
            };
        }
        if (this.player2) {
            data.player2 = {
                playerName: this.player2.playerName,
                delay: this.player2.delay,
                behavior: this.player2.behavior,
                id: this.player2.id,
                email: this.player2.email,
                name: this.player2.name,
                avatar: this.player2.avatar,
                rating: this.player2.rating,
                rank: this.player2.rank,
                difficulty: this.player2.difficulty,
                isDisconnected: this.player2.isDisconnected,
                isMuted: this.player2.isMuted,
                ready: this.player2.ready,
            };
        }
        data.readyPlayer1 = this.readyPlayer1;
        data.readyPlayer2 = this.readyPlayer2;
        data.messagePlayer1 = this.messagePlayer1;
        data.messagePlayer2 = this.messagePlayer2;
        data.matchWinner = this.matchWinner;
        data.elaspedTime = this.elaspedTime;
        data.eventLog = [];
        if (includeLogs) data.eventLog = (this.eventLog || []).slice();
        data.playerTurn = this.playerTurn;
        data.dealer = this.dealer;
        data.playCount = this.playCount;
        data.goPlayer = this.goPlayer;
        data.roundNumber = this.roundNumber;
        data.roundLog = this.roundLog;
        data.matchPoints = this.matchPoints;
        data.matchWinPoints = this.matchWinPoints;
        data.matchSkunkPoints = this.matchSkunkPoints;
        data.isSkunked = this.isSkunked;
        data.startTime = this.startTime;
        data.currentState = this.currentState;
        data.boardName = this.boardName;
        data.deck = this.deck;
        data.background = this.background;
        data.dealerStart = this.dealerStart;
        data.allowRematch = this.allowRematch;
        data.quitReason = this.quitReason;
        // if (this.debug) {
        //     this.logEvent(JSON.stringify(data, null, 4)); //logEvent(JSON.stringify(eventItem, null, 0));
        // }

        return data;
    }
    load(data) {
        //could move all data to variable container with zero logic, might need to change states to be string based, but then it cant create new state on change, just route to state
        try {
            this.id = data.id;
            if (data.level) this.level = data.level;
            this.isPrivateGame = data.isPrivateGame;
            this.allowFullChat = data.allowFullChat;
            this.isRanked = data.isRanked;
            this.room = data.room;
            this.cards = data.cards;
            this.tablePositions = data.tablePositions;
            //this.player1 = new PlayerComputer(this, data.player1.playerName, data.player1.delay, data.player1.behavior, data.player1.difficulty);
            //this.player2 = new PlayerComputer(this, data.player2.playerName, data.player2.delay, data.player2.behavior, data.player2.difficulty);
            this.player1 = data.player1;
            this.player2 = data.player2;
            this.readyPlayer1 = data.readyPlayer1;
            this.readyPlayer2 = data.readyPlayer2;
            this.messagePlayer1 = data.messagePlayer1;
            this.messagePlayer2 = data.messagePlayer2;
            this.matchWinner = data.matchWinner;
            this.elaspedTime = data.elaspedTime;
            this.eventLog = data.eventLog;
            this.playerTurn = data.playerTurn;
            this.dealer = data.dealer;
            this.playCount = data.playCount;
            this.goPlayer = data.goPlayer;
            this.roundNumber = data.roundNumber;
            this.roundLog = data.roundLog;
            this.matchPoints = data.matchPoints;
            this.matchWinPoints = data.matchWinPoints;
            this.matchSkunkPoints = data.matchSkunkPoints;
            this.isSkunked = data.isSkunked;
            this.startTime = data.startTime;
            this.currentState = data.currentState;//state, can skip set state if game model is already setup
            this.boardName = data.boardName;
            this.deck = data.deck;
            this.background = data.background;
            this.dealerStart = data.dealerStart;
            this.allowRematch = data.allowRematch;
            this.quitReason = data.quitReason;
            this.setState(data.currentState);


            //clean old computer
            //todo: set computer by name
            //if (this.playerComputer !== null) this.playerComputer.cleanUp();
            //this.playerComputer =  new PlayerComputer(this);

        } catch (exception) {
            this.logEvent("Failed to load saved game: " + exception);
        }

    }
    updateData(data) {
        //could move all data to variable container with zero logic, might need to change states to be string based, but then it cant create new state on change, just route to state
        try {
            this.id = data.id;
            if (data.level) this.level = data.level;
            this.isPrivateGame = data.isPrivateGame;
            this.allowFullChat = data.allowFullChat;
            this.isRanked = data.isRanked;
            this.room = data.room;
            this.cards = data.cards;
            this.tablePositions = data.tablePositions;
            //todo: cant keep adding playercomputer as it will add more auto events
            //todo: one auto player is good, but maybe not part of the core game
            //todo: just save the player data, not the user.
            this.player1 = data.player1 || {};
            this.player2 = data.player2 || {};
            this.readyPlayer1 = data.readyPlayer1;
            this.readyPlayer2 = data.readyPlayer2;
            this.messagePlayer1 = data.messagePlayer1;
            this.messagePlayer2 = data.messagePlayer2;
            this.matchWinner = data.matchWinner;
            this.elaspedTime = data.elaspedTime;
            this.eventLog = data.eventLog;
            this.playerTurn = data.playerTurn;
            this.dealer = data.dealer;
            this.playCount = data.playCount;
            this.goPlayer = data.goPlayer;
            this.roundNumber = data.roundNumber;
            this.roundLog = data.roundLog;
            this.matchPoints = data.matchPoints;
            this.matchWinPoints = data.matchWinPoints;
            this.matchSkunkPoints = data.matchSkunkPoints;
            this.isSkunked = data.isSkunked;
            this.startTime = data.startTime;
            this.currentState = data.currentState;//state, can skip set state if game model is already setup
            this.boardName = data.boardName;
            this.deck = data.deck;
            this.background = data.background;
            this.dealerStart = data.dealerStart;
            this.allowRematch = data.allowRematch;
            this.quitReason = data.quitReason;
        } catch (exception) {
            this.logEvent("Failed to load saved game: " + exception);
        }
    }
    diff(oldData) {
        //get diff from current data
        //https://github.com/benjamine/JsonDiffPatch
        let data = this.save();

        //clean up data
        data.eventLog = [];//clear logs
        if (data.roundLog && data.roundLog.length > 0) data.roundLog[0] = null; //workaround: Causes a diff on every diff. undefined turns in to null when data is copied into old data. 

        if (oldData) {
            oldData.eventLog = [];//clear logs
        }
        let delta = this.jsondiffpatch.diff(oldData, data);
        return delta;
    }
    patch(delta) {
        //patch original
        //https://github.com/benjamine/JsonDiffPatch
        let data = this.save();
        this.jsondiffpatch.patch(data, delta);
        this.updateData(data);
    }
    canResume() {
        if (this.level === "Online") return false;
        if (this.currentState === "preGame") return false;
        if (this.currentState === "endMatch") return false;
        if (this.currentState === "quit") return false;

        return true;
    }
    //checkForGameOver() {
    //    //watch events? or just code checkForGameOver on each action when points are awarded
    //    // this.checkForGameOver();
    //}


    //------------------------------------------------

    //--------------------Card board Class------------//
    getPileIDs(pileName) {
        let pile = this.getPile(pileName);
        let pileIds = new Array();
        for (var i = 0; i < pile.length; i++) {
            let card = pile[i];
            pileIds.push(card.id);
        }
        return pileIds;
    }
    getPile(pileName) {
        var pileCards = new Array();
        for (var i = 0; i < this.cards.length; i++) {
            let card = this.cards[i];
            if (card.pile === pileName) {
                pileCards.push(card);
            }
        }
        pileCards = this.sortByKey(pileCards, "pilez");
        return pileCards;
    }
    getCardsByOwner(owner) {
        var cards = new Array();
        for (var i = 0; i < this.cards.length; i++) {
            let card = this.cards[i];
            if (card.owner === owner) {
                cards.push(card);
            }
        }
        cards = this.sortByKey(cards, "pilez");
        return cards;
    }
    getCard(cardId) {
        var cards = this.cards.filter(function (obj) {
            return obj.id === cardId;
        });
        var card = cards[0];
        return card;
    }
    sortPile(pileName, descending, key) {
        var pileCards = this.getPile(pileName);
        if (!key) key = "number";
        pileCards = this.sortByKey(pileCards, key, descending);
        for (let i = 0; i < pileCards.length; i++) {
            pileCards[i].pilez = i;
        }
        this.sendEvent("cardMoved");
    }
    isPileSorted(cards, descending, key) {
        if (!key) key = "number";
        let lastCard = null
        for (let i = 0; i < cards.length; i++) {
            let card = cards[i];
            if (lastCard) {
                if (!descending) {
                    if (card[key] < lastCard[key]) {
                        return false;
                    }
                }
                if (descending) {
                    if (card[key] > lastCard[key]) {
                        return false;
                    }
                }
            }
            lastCard = card;
        }
        return true;
    }
    addToPile(card, pileName, player) {

        if (card === undefined) return;

        //todo: getcard owner;
        //var player = this.getCardOwner(card);

        let oldPile = card.pile;

        //update order of "to" pile
        var pileCards = this.getPile(pileName);
        pileCards = this.sortByKey(pileCards, "pilez");
        for (let i = 0; i < pileCards.length; i++) {
            pileCards[i].pilez = i;
        }
        //add to pile
        card.pile = pileName;
        card.pilez = pileCards.length;
        card.isSelected = false;

        //update order of "from" pile
        let fromPile = this.getPile(oldPile);
        fromPile = this.sortByKey(fromPile, "pilez");
        for (let i = 0; i < fromPile.length; i++) {
            fromPile[i].pilez = i;
        }

        //todo: send who did the action, not owner of card or both?
        this.sendEvent("cardMoved", { 'card': card.id, 'pile': pileName }, player);

        this.lastCardPlayedTime = this.getElaspedTime();
    }
    sortByKey(array, key, descending) {
        return array.sort(function (a, b) {
            var x = a[key];
            var y = b[key];
            if (descending) {
                return ((x > y) ? -1 : ((x < y) ? 1 : 0));
            }
            else {
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            }
        });
    }
}